import { defaultState } from "@/shared/utilities/constants";

export default () => ({
  roles: { ...defaultState },
  permissions: { ...defaultState }
});
